import React, { useEffect } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { Link, useNavigate } from "react-router-dom";
import Owner from "../../assets/Owner.png";
import Chart from "../../assets/Chart.png";
import Timetable from "../../assets/TimeTable.png";
import PaymentReceived from "../../assets/PaymentReceived.png";
import Pricing from "../../assets/Pricing.png";
export default function ClubOwnersInfo() {
  const { user } = useAuthContext();
  const navi = useNavigate();

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className=" mt-5 pb-3">
      <div className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Owner}
                alt="Different types of clubs using Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Who Is Membotic For?</h2>
              <p>
                Membotic is built for all kinds of clubs and group-based
                businesses. Whether you're running structured sessions or
                flexible drop-ins, the platform works for you.
              </p>
              <p>Perfect for:</p>
              <ul>
                <li>Fitness & Bootcamps</li>
                <li>Dance Schools & Studios</li>
                <li>Martial Arts Clubs</li>
                <li>Yoga & Pilates Instructors</li>
                <li>Children’s Activity Groups</li>
                <li>Swimming Clubs</li>
                <li>Sports Coaching & Training</li>
                <li>Community Groups & Social Clubs</li>
              </ul>
              <p>
                If your club runs sessions and needs bookings, payments, and
                member management — Membotic is made for you.
              </p>
              <p>
                <strong>Simple to use. Powerful to grow.</strong>
              </p>
              <button
            onClick={() => navi("/whoismemboticfor")}
            className="saveChanges-button"
          >
            Find Out More
          </button>
            </div>

     
          </div>
        </div>
      </div>
      <div className="bg-white py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Chart}
                alt="Club instructor using Membotic"
                className="img-fluid rounded"
              />
            </div>

            <div className="col-md-6">
              <h2>Build Your Club’s Online Presence</h2>
              <p>
                Membotic is a platform where you can create a public profile for
                your club — making it easy for people to find you, learn about
                your offerings, and get involved.
              </p>

              <p>
                <strong>
                  Your club profile becomes your central hub — shareable,
                  searchable, and easy to manage.
                </strong>
              </p>

              <button
                onClick={() => navi("/examplePage")}
                className="saveChanges-button mt-3"
              >
                See Example Club Page
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Timetable}
                alt="Viewing class timetable on Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Make Your Timetable Public</h2>
              <p>
                Membotic lets you share a live, interactive timetable so people
                can easily see when your classes run and how to join them.
              </p>
              <ul>
                <li>Display all your weekly classes in one place</li>
                <li>Show class times, names, and descriptions</li>
                <li>Let users book directly from the timetable</li>
                <li>Keep it updated automatically when you make changes</li>
              </ul>
              <p>
                It’s the easiest way to manage your schedule and help members
                stay in the loop.
              </p>
              <p>
                <strong>
                  Your timetable, your way — and always up to date.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={PaymentReceived}
                alt="Club owner handling payments on Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Handle Payments Without the Hassle</h2>
              <p>
                Membotic makes it easy to collect payments for your classes,
                memberships, or drop-ins — all securely and automatically.
              </p>
              <ul>
                <li>Accept card payments directly through your club profile</li>
                <li>Set prices for PAYG sessions or monthly memberships</li>
                <li>
                  Automate renewals and get notified when payments come in
                </li>
                <li>
                  Track payment history and manage payouts to your account
                </li>
              </ul>
              <p>
                No more chasing money or dealing with cash — Membotic handles it
                all for you.
              </p>
              <p>
                <strong>Get paid on time, every time.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side: Image */}
            <div className="col-md-6 text-center mb-4 mb-md-0">
              <img
                src={Pricing}
                alt="Pricing and plans on Membotic"
                className="img-fluid rounded"
              />
            </div>

            {/* Right Side: Text */}
            <div className="col-md-6">
              <h2>Pricing</h2>
              <p>
                Membotic is designed to be affordable and flexible — no hidden
                costs, no setup fees, and you can cancel anytime.
              </p>
              <ul>
                <li>
                  <strong>First 30 days free</strong> – try all features with no
                  commitment
                </li>
                <li>
                  <strong>£10/month per club</strong> – flat platform fee for
                  unlimited use
                </li>
                <li>
                  Only additional fees are Stripe’s standard processing fees
                </li>
                <li>No contracts, cancel whenever you like</li>
              </ul>
              <p>
                Whether you're just starting or already running a busy club,
                Membotic gives you powerful tools without the heavy price tag.
              </p>
              <p>
                <strong>Start free and grow at your own pace.</strong>
              </p>
              <button
                onClick={() => navi("/pricing")}
                className="saveChanges-button"
              >
                Find out more
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="py-5 text-center bg-white">
        <div className="container">
          <h2 className="mb-4">Ready to Get Started?</h2>
          <p className="mb-4">
            Join hundreds of club owners already using Membotic to simplify
            bookings, payments, and growth.
            <br />
            Start your free 30-day trial today — no setup fees, no commitment.
          </p>
          <button
            onClick={() => navi(`${user ? "/CreateClub" : "/Register"}`)}
            className="saveChanges-button fs-5"
          >
            Start Now
          </button>
        </div>
      </div>
    </div>
  );
}
